export default "__VITE_ASSET__kbj6r3y___"